import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = (type: 'all' | 'necessary') => {
    localStorage.setItem('cookieConsent', type);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50 animate-[slideUp_0.5s_ease-out]">
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-3">
        <p className="text-gray-700 text-sm mb-3 leading-relaxed">
          Käytämme välttämättömiä evästeitä sivuston toimivuuden varmistamiseen ja analytiikkaevästeitä palvelun kehittämiseen.{' '}
          <a href="/terms#cookies" className="text-[#1E3A8A] hover:underline font-medium">
            Lue lisää
          </a>
        </p>
        
        <div className="flex gap-2">
          <button
            onClick={() => handleAccept('necessary')}
            className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap font-medium text-gray-700"
          >
            Vain välttämättömät
          </button>
          <button
            onClick={() => handleAccept('all')}
            className="flex-1 px-3 py-2 text-sm bg-[#1E3A8A] text-white rounded-lg hover:bg-[#1E40AF] transition-colors cursor-pointer whitespace-nowrap font-medium"
          >
            Hyväksy kaikki
          </button>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
